// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

class BreedAPI extends MainAPI {
	/**
	 * @return {object} breeds list
	 */
	async getBreeds() {
		return API.get(ENDPOINTS.GET_BREEDS);
	}

	/**
	 * @return {object} breeds list
	 * @param {number} breedSizeId
	 */
	async getBreedsBySize(breedSizeId) { 
		// if breed size id is 6(All) remove query params
		const endpoint = breedSizeId === 6 ? ENDPOINTS.GET_BREEDS : `${ENDPOINTS.GET_BREEDS}?breedSize=${breedSizeId}`
		
		return API.get(endpoint);
	}

	/**
	 * @return {object} breeds info; general, health, exercise
	 */
	async getBreedInfo(breedId) {
		return API.get(`${ENDPOINTS.GET_BREEDS}/${breedId}/info`);
	}

	/**
	 * @return {object} breed info for health alerts notification
	 */
	async getBreedInfoByID(infoId) {
		return API.get(`${ENDPOINTS.GET_BREED_INFO}/${infoId}`);
	}

	/**
	 * @return {object} list of breeds
	 * @params queryParams
	 */
	 async getBreedList(queryParams) {
		return API.get(`${ENDPOINTS.GET_BREEDS_MANAGEMENT}?${queryString.stringify(queryParams)}`);
	}

	async updateStatusBreed(id, body) {
		return API.put(`${ENDPOINTS.PUT_BREEDS}/${id}/status`, body);
	}

	async saveBreed(breedDetails) {
		return API.post(`${ENDPOINTS.POST_BREEDS}`, breedDetails);
	}

	/**
	 * @return {object} breeds details
	 */
	 async getBreedById(breedId) {
		return API.get(`${ENDPOINTS.GET_BREEDS}/${breedId}`);
	}

	async updateBreed(breedDetails) {
		return API.put(`${ENDPOINTS.PUT_BREEDS}`, breedDetails);
	}

	async deleteBreed(breedId) {
		return API.delete(`${ENDPOINTS.DELETE_BREED}/${breedId}`);
	}
}

export default new BreedAPI();